import { FaCar } from "react-icons/fa6";
import TableComponent from "../TableComponent";

const TopVehiclesByCost = ({ topVehicles }) => {
 
  const header = [
    { value: "vehicle.registration_number", label: "Vehicle" },
    { value: "vehicle.vehicle_brand", label: "Vehicle Brand" },
    { value: "total_spent", label: "Total Spent" },
    { value: "last_maintenance_date", label: "Last Maintained Date" },
    { value: "service_ratio", label: "Scheduled to Unscheduled Ratio" },
    // { value: "scheduled_maintenance_date", label: "Scheduled Maintenance Date" },
  ];

  return (
    <div className="card_container">
      <TableComponent
        heading="Top 5 Vehicles by Maintenance Cost"
        icon={<FaCar />}
        columns={header}
        data={topVehicles}
        currentPage={1}
      />
    </div>
  );
};

export default TopVehiclesByCost;
